import { useAuth } from "@src/contexts/AuthProvider";
import { useCreateCompanyToken } from "@src/pages/SuperAdmin/useCreateCompanyToken";
import { notifyError, notifySuccess } from "@src/shared/notify";
import { Page } from "@src/shared/pages";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";

interface UseSwitchToCompany {
  switchToCompany: (companyId: string, companyName: string) => Promise<void>;
}

export const useSwitchToCompany = (): UseSwitchToCompany => {
  const { updateCurrentUserState } = useAuth();
  const { createCompanyToken } = useCreateCompanyToken();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const switchToCompany = async (companyId: string, companyName: string) => {
    const createCompanyTokenData = await createCompanyToken({
      variables: { companyId: companyId },
    });
    const newToken = createCompanyTokenData.data?.createCompanyToken;
    if (newToken) {
      await updateCurrentUserState();
      notifySuccess(`Switched to company ${companyName}`);
      navigate(Page.HOME);
      queryClient.clear();
      return;
    }
    notifyError("Unable to switch to company");
  };

  return { switchToCompany };
};
